import { api } from '../api';

export const pdcGoalReport = api.injectEndpoints({
    endpoints: (builder) => ({
        getPdcGoalReports: builder.query({
            query: (payload) => ({
                url: 'api/report/pdc-goal-report/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list'
                }
            })
        }),
        downloadPdcGoalReports: builder.query({
            query: (payload) => ({
                url: 'api/report/pdc-goal-report/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list'
                },
                responseHandler: (res) =>
                    res.blob().then((blob) => ({
                        blob,
                        fileName: res.headers.get('content-disposition').split('filename=')[1],
                        type: res.headers.get('content-type')
                    }))
            })
        })
    })
});

export const {
    useGetPdcGoalReportsQuery,
    useLazyGetPdcGoalReportsQuery,
    useDownloadPdcGoalReportsQuery,
    useLazyDownloadPdcGoalReportsQuery
} = pdcGoalReport;
